// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TransactionOutlinedSvg from "@fishx/icons-svg/es/asn/TransactionOutlined";
import FishxIcon from '../components/FishxIcon';

var TransactionOutlined = function TransactionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TransactionOutlinedSvg
  }));
};

TransactionOutlined.displayName = 'TransactionOutlined';
export default React.forwardRef(TransactionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TransactionOutlined.js
// module id = 4277
// module chunks = 0